<template>
  <v-row>
    <v-col cols="12">
      <div style="display: flex; justify-content: space-evenly; align-items: center">
        <div @click="goto('/realestate/property/list')"
             class="abad-button">
          <v-icon color="abadPrimary" class="pb-2">
            mdi-home-city
          </v-icon>

          <span class="text-h6">
            Inmuebles
          </span>
        </div>

        <div @click="goto('/realestate/adviser/list')"
             class="abad-button">
          <v-icon color="abadPrimary" class="pb-2">
            mdi-account
          </v-icon>

          <span class="text-h6">
            Asesores
          </span>
        </div>

        <div @click="goto('/realestate/owner/list')"
             class="abad-button">
          <v-icon color="abadPrimary" class="pb-2">
            mdi-account-group
          </v-icon>

          <span class="text-h6">
            Propietarios
          </span>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  methods: {
    goto (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style>
  .abad-button {
    background: white;
    border: solid 1px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    cursor: pointer;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px;
  }
</style>
